<template>
    <div id="progress-bar">
        <p> {{ hint }}</p>
        <div id="progress-bar__bar" :style="style"></div>
    </div>
</template>

<script>
export default {
    name: "ProgressBar",
    props: {
        hint: String,
        percentage: Number
    },
    computed: {
        style() {
            return "width: " + this.percentage + "%";
        }
    }
};
</script>

<style lang="scss" scoped>
$progress-bar__text--colour: #ff6600;
$progress-bar__text--font: "Lato";
$progress-bar__bar--colour: #ff6600;

#progress-bar {
    font-family: $progress-bar__text--font;
    color: $progress-bar__text--colour;
    font-weight: bold;
    position: fixed;
    bottom: 200px;
    left: calc(50% - 150px);
    background-color: #f1f1f1;
    box-shadow: 0 3px 6px -2px rgba(0, 0, 0, 0.2);
    width: 300px;
    height: 60px;
    margin: auto;
    border-radius: 5px;
    padding: 7px 15px;
    box-sizing: border-box;
    text-align: center;

    #progress-bar__bar {
        margin-top: 8px;
        width: 1%;
        height: 15px;
        background-color: $progress-bar__bar--colour;
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
    #progress-bar {

    }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
    #progress-bar {

    }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px)  {
    #progress-bar {

    }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px)  {
    #progress-bar {

    }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px)  {
    #progress-bar {
       
    }
}
</style>